"use client";

import { BottomSheet } from "@artha/ui";

import {
  CREATOR_SOURCE_CONFIG,
  ESTIMATE_EARNINGS_MORE_SOURCE_IDS,
  type OnboardingCreatorSource,
} from "../config/creatorSources";

interface EstimateEarningsMoreSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (provider: OnboardingCreatorSource) => void;
}

export function EstimateEarningsMoreSheet({
  isOpen,
  onClose,
  onSelect,
}: EstimateEarningsMoreSheetProps) {
  const handleSelect = (provider: OnboardingCreatorSource) => {
    onClose();
    onSelect(provider);
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="More platforms"
      desktopPlacement="center"
    >
      <div className="flex flex-col gap-2" role="list">
        {ESTIMATE_EARNINGS_MORE_SOURCE_IDS.map((provider) => {
          const config = CREATOR_SOURCE_CONFIG[provider];
          const Icon = config.estimateIcon;

          return (
            <button
              key={provider}
              type="button"
              role="listitem"
              aria-label={`Continue with ${config.displayName}`}
              className="flex min-h-12 w-full items-center gap-3 rounded-xl border border-[#E4E7EC] px-4 py-3 text-left text-sm font-semibold text-[#344054] transition-colors hover:bg-[#F9FAFB] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0D41E1]"
              onClick={() => handleSelect(provider)}
            >
              <span className="flex size-8 items-center justify-center rounded-lg bg-[#F9FAFB]">
                <Icon className={config.estimateIconClassName} />
              </span>
              <span>{config.displayName}</span>
            </button>
          );
        })}
      </div>
    </BottomSheet>
  );
}
